module.exports = __webpack_public_path__ + "static/1-81048393df3cb76cb405c362ea8385c7.png";